<template>
  <employee :id="me && me.id" />
</template>

<script>
import Employee from "./Employee";
import { mapState } from "vuex";

export default {
  components: {
    Employee
  },
  computed: {
    ...mapState(["me"])
  }
};
</script>
